import React, { useEffect } from "react";
import {FormularioIngresoDocParentesco} from './FormularioIngresoDocParentesco'
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch ,useSelector} from "react-redux";
import {Grid, Typography} from '@material-ui/core';
import { configuracionLimpiar, traerConfiguracionPorTipoParentesco } from "../../../actions/configuraciones/FormularioIngreso";
import { SelectParentesco } from "./SelectParentesco";
import { fetchParentescos } from "../../../actions/cbos/parentescos";



const useStyles = makeStyles({
  rootTitulo:{
      color:'white',
      marginBottom:20
  }
});

export const HomeTiposDeDocumentosParentescos = () => {
    const dispatch = useDispatch();
    const {items} = useSelector((state)=>state.configuraciones)
    const classes = useStyles();
    const handleChange = (event) => {
        dispatch(traerConfiguracionPorTipoParentesco(event.target.value));
      };
    
    useEffect(() => {
        dispatch( configuracionLimpiar() );
        dispatch( fetchParentescos() );
    }, [dispatch]);

  return (
    
    <Grid item lg={12}> 
       <Grid container direction="column" justify="center" alignItems="center">
          <Grid >
            <SelectParentesco apiUrl={'parentescos'}  handleChange={handleChange}/>
          </Grid>
          <Typography component="h3" variant="h5" className={classes.rootTitulo}>Documentos por Parentesco</Typography>
          <Grid>
            <FormularioIngresoDocParentesco items={items} />
          </Grid>
        </Grid>
    </Grid>
  );

};
